import type { State } from '@multiplekex/shallot';
import type { RecordSequenceConfig } from '@blog-components/sequence';
import { findSequenceForTransition, setCanvasSize, encodeSequence } from './core';

export function setupCanvasRecording(canvas: HTMLCanvasElement, state: State): void {
  canvas.__recordSequence__ = async (
    config: RecordSequenceConfig,
    onProgress?: (frame: number, total: number) => void
  ): Promise<Blob | null> => {
    const seqEid = findSequenceForTransition(state, config.fromStep, config.toStep);
    if (seqEid === null) return null;

    const origWidth = canvas.width;
    const origHeight = canvas.height;
    const origStyle = canvas.style.cssText;

    // Pause visibility loop to prevent double-stepping
    canvas.__paused__ = true;

    setCanvasSize(canvas, config.width, config.height);
    await new Promise((r) => requestAnimationFrame(r));

    const blob = await encodeSequence(canvas, state, seqEid, config, onProgress);

    // Restore canvas size
    canvas.width = origWidth;
    canvas.height = origHeight;
    canvas.style.cssText = origStyle;

    // Resume visibility loop
    canvas.__paused__ = false;

    return blob;
  };
}
